<template>
  <div>
    <el-drawer
      v-if="visible"
      :visible.sync="visible"
      :size="1100"
      :title="title"
      append-to-body
      :with-header="false"
      :before-close="handleClose"
    >
      <div class="d-flex" style="justify-content: space-between; margin: 20px;">
        <div>
          编辑物料
        </div>
        <el-button size="small" @click="handleClose()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
      </div>

      <EditMaterialForm
        class="m-4"
        ref="editMaterialFormInner"
        :productLine="productLine"
        :amzSkuMaterialGroup="amzSkuMaterialGroup"
        :materialCode="materialCode"
        :amzSkuCode="amzSkuCode"
        :amzSkuMaterialCode="amzSkuMaterialCode"
        @close="close"
        @confirm="confirm"
      />
    </el-drawer>
    <CloseDialog :backDialogVisible.sync="backDialogVisible" @close="close" />
  </div>
</template>
<script>
import EditMaterialForm from './index.vue'
import CloseDialog from '../close-dialog/index.vue'
export default {
  components: {
    EditMaterialForm,
    CloseDialog,
  },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    amzSkuMaterialGroup: { type: String, default: '' },
    materialCode: { type: String, default: '' },
    amzSkuCode: { type: String, default: '' },
    amzSkuMaterialCode: { type: String, default: '' },
    productLine: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
    }
  },
  methods: {
    confirm() {
      const data = this.$refs.chooseMaterialInner.choiceData()
      if (!data) {
        return
      }
      this.$emit('confirm', data)
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    handleClose() {
      this.backDialogVisible = true
    },
  },
}
</script>
